import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  getPublishedFormEditorForms,
  getUnpublishedFormEditorForms,
  selectForm,
} from '../../store/slices/formEditorSlice';
import Button from 'components/Button/Button';
import {
  copyFormEditorFormThunk,
  deleteFormEditorFormThunk,
} from '../../store/thunks/formEditorThunks';

export function FormsListView() {
  const dispatch = useDispatch();
  const history = useHistory();

  const publishedForms = useSelector(getPublishedFormEditorForms);
  const unpublishedForms = useSelector(getUnpublishedFormEditorForms);

  // track hover per section so duplicates don't both glow
  const [hoveredKey, setHoveredKey] = useState(null);

  const onSelectForm = (form) => {
    dispatch(selectForm(form));
    history.push(`/form-editor/${form.id}`);
  };

  function Row({ note, idx, isPublished }) {
    const isHovered = hoveredKey === `${note.id}`;

    return (
      <div
        key={`${note.id}`}
        role="button"
        tabIndex={0}
        onMouseEnter={() => setHoveredKey(`${note.id}`)}
        onMouseLeave={() => setHoveredKey(null)}
        onClick={() => onSelectForm(note)}
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr auto',
          alignItems: 'center',
          gap: 14,
          padding: '16px 18px',
          cursor: 'pointer',
          background: isHovered ? '#005a7f' : '#147ba4',
          borderTop: idx === 0 ? 'none' : '1px solid rgba(255,255,255,0.08)',
          transition: 'all .2s ease',
          transform: isHovered ? 'translateY(-1px)' : 'none',
          boxShadow: isHovered
            ? '0 4px 12px rgba(74, 211, 255, 0.15)'
            : '0 0 0 rgba(0,0,0,0)',
        }}
      >
        {/* avatar / icon */}
        <div
          aria-hidden
          style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#FFFFFF',
            fontWeight: 800,
            letterSpacing: 0.3,
            background: 'linear-gradient(180deg, #79ffe1 0%, #4ad3ff 100%)',
            boxShadow: isHovered
              ? 'inset 0 0 0 1px rgba(255,255,255,0.4), 0 4px 8px rgba(74, 211, 255, 0.2)'
              : 'inset 0 0 0 1px rgba(255,255,255,0.25)',
            transform: isHovered ? 'scale(1.02)' : 'scale(1)',
            transition: 'all .2s ease',
          }}
        >
          {(note.name || 'N').slice(0, 1).toUpperCase()}
        </div>

        {/* main content */}
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontSize: 16,
              fontWeight: 650,
              lineHeight: 1.25,
              marginBottom: 6,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: '#fff',
            }}
            title={note.name}
          >
            {note.name || 'Nimeämätön lomakepohja'}
          </div>

          {/* meta chips */}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {/* You can toggle/replace this later depending on real status */}

            {isPublished ? (
              <span
                style={{
                  fontSize: 12,
                  padding: '4px 8px',
                  background: 'rgba(74, 211, 255, 0.2)',
                  color: '#4ad3ff',
                  border: '1px solid rgba(74, 211, 255, 0.3)',
                  fontWeight: 600,
                }}
              >
                Julkaistu
              </span>
            ) : (
              <span
                style={{
                  fontSize: 12,
                  padding: '4px 8px',
                  background: 'rgba(255,255,255,0.1)',
                  color: 'rgba(255,255,255,0.7)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  fontWeight: 600,
                }}
              >
                Julkaisematon
              </span>
            )}
            {note.businessId ? (
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                  fontSize: 12,
                  padding: '4px 8px',
                  background: 'rgba(121, 255, 225, 0.2)',
                  color: '#79ffe1',
                  border: '1px solid rgba(121, 255, 225, 0.3)',
                  fontWeight: 600,
                }}
              >
                <span
                  style={{
                    width: 6,
                    height: 6,
                    background: '#79ffe1',
                  }}
                />
                {String(note.businessId)}
              </span>
            ) : null}
            <button
              style={{
                fontSize: 12,
                padding: '4px 8px',
                background: 'rgba(255,255,255,0.1)',
                color: 'rgba(255,255,255,0.8)',
                border: '1px solid rgba(255,255,255,0.2)',
                fontWeight: 600,
                cursor: 'pointer',
                borderRadius: 0,
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.15)';
                e.target.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.1)';
                e.target.style.color = 'rgba(255,255,255,0.8)';
              }}
              onClick={(e) => {
                e.stopPropagation();
                console.log('NOTE', note);
                dispatch(copyFormEditorFormThunk({ formEditorForm: note }));
              }}
            >
              Kopioi
            </button>
            <button
              style={{
                fontSize: 12,
                padding: '4px 8px',
                background: 'rgba(255, 91, 91, 0.2)',
                color: '#ff5b5b',
                border: '1px solid rgba(255, 91, 91, 0.3)',
                fontWeight: 600,
                cursor: 'pointer',
                borderRadius: 0,
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255, 91, 91, 0.3)';
                e.target.style.color = '#ff3333';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'rgba(255, 91, 91, 0.2)';
                e.target.style.color = '#ff5b5b';
              }}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(
                  deleteFormEditorFormThunk({ formEditorFormId: note.id })
                );
                console.log('Delete form:', note.id);
              }}
            >
              Poista
            </button>

            {note.updatedAt && (
              <span
                style={{
                  fontSize: 12,
                  padding: '4px 8px',
                  background: 'rgba(255,255,255,0.05)',
                  color: 'rgba(255,255,255,0.6)',
                  border: '1px solid rgba(255,255,255,0.15)',
                  fontWeight: 500,
                }}
                title={new Date(note.updatedAt).toLocaleString()}
              >
                {new Date(note.updatedAt).toLocaleDateString()}
              </span>
            )}
          </div>
        </div>

        {/* chevron */}
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          aria-hidden
          style={{
            opacity: isHovered ? 1 : 0.55,
            transform: isHovered ? 'translateX(2px)' : 'translateX(0)',
            transition: 'all .2s ease',
            color: '#fff',
          }}
        >
          <path
            fill="currentColor"
            d="M9.29 6.71a1 1 0 0 1 1.42 0l4.58 4.58a1 1 0 0 1 0 1.42l-4.58 4.58a1 1 0 0 1-1.42-1.42L12.17 12 9.29 9.12a1 1 0 0 1 0-1.41Z"
          />
        </svg>
      </div>
    );
  }

  return (
    <div
      style={{
        width: 'clamp(960px, 92vw, 1400px)',
        margin: '32px 16px',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
        color: '#0F172A',
      }}
    >
      <div style={{ marginBottom: 28 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            marginBottom: 12,
          }}
        >
          <h3
            style={{ margin: 0, fontSize: 18, fontWeight: 700, color: 'white' }}
          >
            Julkaistut
          </h3>
          <div style={{ fontSize: 12, opacity: 0.7, color: 'white' }}>
            {publishedForms.length} lomaketta
          </div>
        </div>

        <div
          style={{
            backgroundColor: '#147ba4',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            overflow: 'hidden',
          }}
        >
          {publishedForms.map((note, idx) => (
            <Row key={note.id} note={note} idx={idx} isPublished={true} />
          ))}
        </div>
      </div>
      <div style={{ marginBottom: 28 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            marginBottom: 12,
          }}
        >
          <h3
            style={{ margin: 0, fontSize: 18, fontWeight: 700, color: 'white' }}
          >
            Julkaisemattomat
          </h3>
          <div style={{ fontSize: 12, opacity: 0.7, color: 'white' }}>
            {unpublishedForms.length} lomaketta
          </div>
        </div>

        <div
          style={{
            backgroundColor: '#147ba4',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            overflow: 'hidden',
          }}
        >
          {unpublishedForms.map((note, idx) => (
            <Row key={note.id} note={note} idx={idx} isPublished={false} />
          ))}
        </div>
      </div>
    </div>
  );
}
